/// <amd-module name="PipelinesUI/Components/LogViewer/LineTransform" />
import * as React from "react";
import { Icon } from "VSSUI/Icon";
import { ILine, IParsedFindResult, NodeType } from "../../Utilities/LogParser.Types";
import { getType, Parser } from "../../Utilities/Parser";

// note: we have a test case in AnsiParser.test.ts that tests for XSS
/* tslint:disable:react-no-dangerous-html*/
const HTMLContent = (props: { data: string }) => {
    return (
        <span
            dangerouslySetInnerHTML={{
                __html: props.data
            }}
        />
    );
};
/* tslint:enable:react-no-dangerous-html*/

interface ITransformProps {
    expanded?: boolean;
    section: string;
    subParser: Parser;
    line: ILine;
    raw: string;
    lineNumber: number;
    findResult?: IParsedFindResult;
    pureHTML?: boolean;
    contentId?: string;
}

export class LineTransform extends React.Component<ITransformProps> {
    public render() {
        const props = this.props;
        /* tslint:disable */
        return (
            <>
                {props.line.nodes.map((x) => {
                    const text = (props.raw || "").substring(x.start, x.end + 1);
                    const content = props.subParser.parse(text, props.lineNumber, props.findResult, props.pureHTML, props.contentId);
                    switch (x.type) {
                        case NodeType.Icon:
                            return (
                                <span key={x.index}>
                                    <Icon iconName={text.trim()} className="line-icon" />
                                </span>
                            );
                        case NodeType.Group:
                            return (
                                <span key={x.index}>
                                    <span className="group-expand">
                                        <Icon
                                            iconName={`TriangleSolidRight12 ${props.expanded ? "rotate" : ""}`}
                                            className="group-icon"
                                            role="button"
                                            ariaExpanded={!!props.expanded}
                                            ariaLabel={!!props.expanded ? "collapse" : "expand"}
                                        />
                                        <HTMLContent data={content}/>
                                    </span>
                                </span>
                            );
                        default:
                            return (
                                <span key={x.index} className={`pl-${getType(x)}`}>
                                    <HTMLContent data={content} />
                                </span>
                            );
                    }
                })}
            </>
        );
        /* tslint:enable */
    }
}
